import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { FirebaseStorageService } from './../firebase-storage/firebase-storage.service';
import { FirestoreService } from './../firestore/firestore.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './../storage/storage.service';
import { Injectable } from '@angular/core';

let requestOptions = {
  headers: new HttpHeaders({
    'Access-Control-Allow-Origin': '*/*',
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, authorization',
    'Content-Type': ' application/json',
    Accept: ' */*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class TotalPassService {
  uriApiOrder: string = environment.gluky.ordersApiBasePatch;
  api_key;
  token;
  documentUser;
  dataUser;
  baseUrl =
    'https://totalpass-front-us-east1-cnybo5q4.ue.gateway.dev/cards/v1/';
  constructor(
    private storageServices: StorageService,
    private http: HttpClient,
    private alertService: AlertService,
    private userservice: UserService
  ) {}

  async dataUserfn() {
    return new Promise(async (resolve, reject) => {
      const claims = await this.storageServices.get('gnx-claims');
      const companyId = (claims.programs[0] as string).split('/')[1];
      const programId = (claims.programs[0] as string).split('/')[3];
      this.token = await this.storageServices.get('gnx-token');
      requestOptions.headers.set('Authorization', `Bearer ${this.token}`);
      let dataUser = this.dataUser;
      if (!this.documentUser) {
        this.userservice.getUserInfoWithId().subscribe(
          (res) => {
            this.documentUser = res.docNumber;
            this.dataUser = res;
            dataUser = res;

            resolve({ companyId, programId, claims, dataUser });
          },
          (err) => {
            console.error('dataUserfn getUserInfoWithId err', err);
          }
        );
      } else {
        resolve({ companyId, programId, claims, dataUser });
      }
    });
  }

  async verifyStatusCard() {
    const Userdata: any = await this.dataUserfn();

    let data = {
      documento: this.documentUser,
      companyId: Userdata.companyId,
      programId: Userdata.programId,
    };
    let postData = { data: data };
    return new Promise((resolve, reject) =>
      this.http
        .post(`${this.baseUrl}status`, JSON.stringify(postData), requestOptions)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error: HttpErrorResponse) => {
            console.log('error verifyStatusCard', error);
            this.hendlerError(error);
            reject(error);
          }
        )
    );
  }

  async activateCard(card: string) {
    const Userdata: any = await this.dataUserfn();
    let data = {
      documento: this.documentUser,
      tarjeta: card,
      companyId: Userdata.companyId,
      programId: Userdata.programId,
    };
    let postData = { data: data };
    return new Promise((resolve, reject) =>
      this.http
        .post(
          `${this.baseUrl}activate`,
          JSON.stringify(postData),
          requestOptions
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log('error verifyStatusCard', error);
            reject(error);
          }
        )
    );
  }

  async configProgram() {
    const Userdata: any = await this.dataUserfn();
    return new Promise((resolve, reject) =>
      this.http
        .get(
          `${this.baseUrl}companies/${Userdata.companyId}/programs/${Userdata.programId}?points=0`,
          requestOptions
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log('error configProgram', error);
            this.hendlerError(error);
            reject(error);
          }
        )
    );
  }
  async getInfoRechargeCard(amount: number = 0) {
    const Userdata: any = await this.dataUserfn();

    return new Promise((resolve, reject) =>
      this.http
        .get(
          `${this.baseUrl}companies/${Userdata.companyId}/programs/${Userdata.programId}?points=${amount}`,
          requestOptions
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log('error getInfoRechargeCard', error);
            this.hendlerError(error);
            reject(error);
          }
        )
    );
  }

  async rechargeCard(infoForm) {
    const Userdata: any = await this.dataUserfn();
    let data = {
      ...infoForm,
      companyId: Userdata.companyId,
      programId: Userdata.programId,
    };
    data.monto = infoForm.valueRecharge;
    delete data.valueRecharge;
    let postData = { data: data };

    Object.values(data).forEach((value: any) => {
      if (!value || !value.toString().trim()) {
        this.alertService.presentAlert('Favor de llenar todos los campos');
        throw false;
      }
    });

    return new Promise((resolve, reject) =>
      this.http
        .post(
          `${this.baseUrl}recharge`,
          JSON.stringify(postData),
          requestOptions
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log('error rechargeCard', error);
            this.hendlerError(error);
            reject(error);
          }
        )
    );
  }

  getError(code) {
    const codes = {
      UNDER_RANGE: 'Monto inferior al permitido',
      VALIDATION_ERROR: 'Error de Validación en consulta',
      OVER_RANGE: 'Monto superior al permitido',
      NOT_ENOUGH_POINTS: 'Coins Insuficientes',
      INTERNAL_SERVER_ERROR: 'Error Interno del Servidor',
      DEFAULT: `Error en Consulta [${code}]`,
    };
    return codes[code] || codes.DEFAULT;
  }

  hendlerError(error: HttpErrorResponse) {
    if (error.status == 400) {
      this.alertService.presentAlert(this.getError(error.error.code));
    } else if (error.status == 500) {
      //TODO: Make something whit this error, error validated in General handler errors
      // this.alertService.presentAlert(this.getError(error.error.code));
    }
  }
}
